export default __webpack_public_path__ + "static/media/PortraitUnselect.d1b15d97.svg";